import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=b2a18550&scoped=true"
import script from "./Players.vue?vue&type=script&lang=js"
export * from "./Players.vue?vue&type=script&lang=js"
import style0 from "./Players.vue?vue&type=style&index=0&id=b2a18550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a18550",
  null
  
)

export default component.exports